import React from 'react';
import AppStore from 'Assets/images/app-store.png';
import playStore from 'Assets/images/play-store.png';
import { Link } from 'react-router-dom';

function DiscountBanner() {
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="discount-banner-image">
            <Link
              to="https://apps.apple.com/in/app/unipath-blood-test/id6711355606"
              target="_blank"
            >
              <img
                id="appStore"
                src={AppStore}
              />
            </Link>
            <Link
              to="https://play.google.com/store/apps/details?id=com.unipath"
              target="_blank"
            >
              <img
                id="playStore"
                src={playStore}
              />
            </Link>
            <p id="termsAndConditions">
              <Link to="/terms-of-use">*Terms and Conditions Apply</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DiscountBanner;
